import type { QueryClient } from '@tanstack/react-query';
import type { LoaderFunctionArgs, ShouldRevalidateFunctionArgs } from 'react-router';

import { requireAuthorizedInsightsUser } from '#utils/auth.ts';
import { getParsedSearchParams } from './Home.utils.ts';

export const loader = (queryClient: QueryClient) => async (args: LoaderFunctionArgs) => {
  await requireAuthorizedInsightsUser(queryClient);
  const searchParams = new URL(args.request.url).searchParams;
  return getParsedSearchParams(searchParams);
};

export function shouldRevalidate(args: ShouldRevalidateFunctionArgs) {
  // Remove trailing slashes to handle cases where the URL might have them
  const pathname = args.currentUrl.pathname.replace(/\/+$/, '');

  // Don't revalidate when drilldown routes are rendered, as they change search
  // params that are shared with the home route.
  if (pathname === '/appointments/drilldown' || pathname === '/forms/drilldown') {
    return false;
  }

  return args.defaultShouldRevalidate;
}
